module.exports = __webpack_public_path__ + "img/default-google-maps-chevy.60b614d9.png";